import { createApi } from "../axiosInstance";
import { createProductApi } from "../shared/productApiFactory";

const api = createApi("myBusiness");

export const {
  createProduct,
  getProductById,
  getProducts,
  updateProduct,
  deleteProduct,
  getProductByHsn,
  getUnits,
  getUnitDetails,
  getProductCategories,
  getProductCategoryById,
  createProductCategory,
  updateProductCategory,
  deleteProductCategory,
  getSubCategories,
  getSubCategoryById,
  createProductSubCategory,
  updateSubCategory,
  deleteProductSubCategory,
  getTransactionsByProductId,
  addProductTransaction,
  deleteTransaction,
  updateTransaction,
  getTransactionsIdByProductId,
  getTransactions,
  getTransactionById,
  getFPOProductQuantities,
  downloadFPOProductQuantities,
} = createProductApi(api);
